module.exports = __webpack_public_path__ + "static/media/dm6.37a247dc.svg";